(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["best-selling"] && !Shopify.designMode) return;
  try {
    
    $(document).ready(function(){
      $('.bestSellingCarousel').owlCarousel({
        loop:true,
        margin:0,
        dots: false,
        loop: true,
        autoplay: true,
        nav: true,
        navText : ['<svg xmlns="http://www.w3.org/2000/svg" width="16" height="24" viewBox="0 0 16 24" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.5 3L6.5 12L15.5 21L12.5 24L0.5 12L12.5 0L15.5 3Z" fill="white"/></svg>','<svg xmlns="http://www.w3.org/2000/svg" width="16" height="24" viewBox="0 0 16 24" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.5 21L9.5 12L0.5 3L3.5 0L15.5 12L3.5 24L0.5 21Z" fill="white"/></svg>'],
        items:1
     })
  })  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["explore-products"] && !Shopify.designMode) return;
  try {
    
    $(document).ready(function(){
      $('.sidebar ul li:first-child').addClass('active');
      $('.exploreProductGridInner').hide();
      $('.exploreProductGridInner:first').show();
      $('.sidebar ul li, .exploreProductGridHead>ul>li>ul>li').on('click', function(){
         $('.sidebar ul li').removeClass('active');
         $(this).addClass('active');
         $('.exploreProductGridInner').hide();
         var activeTab = $(this).attr('data-set');
         $(`#${activeTab}`).fadeIn();
      });
    });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  $('.clientfooterLogoInner').owlCarousel({
    loop:true,
    margin:10,
    nav:false,
    responsive:{
        0:{
            items:1
        },
        600:{
            items:3
        },
        1000:{
            items:9
        }
    }
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["local-testimonial"] && !Shopify.designMode) return;
  try {
    
    $(document).ready(function(){
      $('.localTestimonialCarousel').owlCarousel({
        loop:true,
        margin:36,
        dots: false,
        loop: true,
        autoplay: true,
        nav: false,
        responsiveClass:true,
        responsive:{
            0:{
                items:1,
               margin:0
            },
            767:{
                items:2,
               margin:20
            },
            1220:{
                items:3
            }
        }
     })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logo-slider"] && !Shopify.designMode) return;
  try {
    
    $(document).ready(function(){
      $('.logosliderCarousel').owlCarousel({
        margin:16,
        dots: false,
        loop: true,
        autoplay: true,
        nav: false,
        responsiveClass:true,
        responsive:{
            0:{
                items:2
            },
            600:{
                items:3
            },
            749:{ 
                items:4
            },
            989:{
                items:5
            },
            1080:{
                items:6
            },
            1400:{
                items:7
            }
        }
     })
  })  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
    $(document).ready(function(){
       $('.collectionGridViewHead, .powerType, .deliveryFeatures, #gf-controls-container').wrapAll('<div class="collHeadwrapper"></div>');
      $('body').on('click', '.filterBtn', function(){
        $('.gf-filter-trigger span').trigger('click');
      });
      $('body').on('click', '.listView', function(){
        $('#gf-products').removeClass('productGridView');
        $('#gf-products').addClass('productListView');
      });
      $('body').on('click', '.gridView', function(){
         $('#gf-products').removeClass('productListView');
         $('#gf-products').addClass('productGridView');
      });
      
     //  $('.productSliderCarousel').owlCarousel({
     //    dots: false,
     //    loop: true,
     //    autoplay: true,
     //    nav: true,
     //    navText: ['<svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none"><path d="M13.4557 1.71933L6.59908 8.65L13.4551 15.5807L12.3884 16.6353L4.48975 8.65L12.3897 0.66333L13.4564 1.71866L13.4557 1.71933Z" fill="black"/></svg>', '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none"><path d="M3.51385 1.71933L10.3699 8.65L3.51385 15.5807L4.58052 16.6353L12.4798 8.65L4.57985 0.66333L3.51318 1.71866L3.51385 1.71933Z" fill="black"/></svg>'],
     //    responsiveClass:false,
     //    onInitialized: updateCounter,
     //    onChanged: updateCounter,
     //    responsive:{
     //        0:{
     //           items:1,
     //           margin:0
     //        },
     //        480:{
     //           items:2,
     //           margin:0
     //        },
     //        750:{
     //            items:1,
     //           margin:20
     //        },
     //        990:{
     //            items:2,
     //           margin:20
     //        },
     //       1080:{
     //           items:3,
     //           margin:20 
     //        },
     //        1280:{
     //           items:4,
     //           margin:20 
     //        },
     //       1600:{
     //           items:5,
     //           margin:20
     //        }
     //    }
     // })
      
    function updateCounter(event) {
      var current = event.item.index - event.relatedTarget._clones.length / 2 + 1;
      var total = event.item.count;
  
      if (current > total) current = current - total;
      if (current < 1) current = total + current;
  
      $('.custom-counter .current').text(current);
      $('.custom-counter .total').text(total);
    }


  });

  $(window).on('load', function() {
     function initPowerTypeSlider() {
        if ($(window).width() < 1280) {
          //if (!$('.powerType ul').hasClass('owl-loaded')) {
            $('.powerType ul').addClass('owl-carousel').owlCarousel({
              items: 2,
              margin: 20,
              nav: false,
              dots: true,
              loop:true,
              responsive: {
                0: { items: 1.5 },
                480:{ items:2 },
                600: { items: 2.2 },
                750: { items: 1.2 },
                990: { items: 2.2 },
                1080: { items:2.5 }
              }
            });
          //}
        } else {
          if ($('.powerType ul').hasClass('owl-loaded')) {
            $('.powerType ul').trigger('destroy.owl.carousel').removeClass('owl-carousel owl-loaded');
            $('.powerType ul').find('.owl-stage-outer').children().unwrap();
          }
        }
      }
          

    // Run on window resize
    $(window).resize(function () {
      initPowerTypeSlider();
    });
    
    
    function updateCounter11(event) {
      var current = event.item.index - event.relatedTarget._clones.length / 2 + 1;
      var total = event.item.count;
  
      if (current > total) current = current - total;
      if (current < 1) current = total + current;
  
      $('.custom-counter .current').text(current);
      $('.custom-counter .total').text(total);
    }
    setTimeout(function(){
        
        let powerhtml = $('#customcollectionHeader').html();
        $(powerhtml).insertBefore($('#gf-controls-container'));
      
        let topProductSlider_Wrap = $('#topProductSlider_Wrap').html();
        $(topProductSlider_Wrap).insertAfter($('#gf-products li:nth-child(6)'));
      
        let installationServices_Wrap = $('#installationServices_Wrap').html();
        $(installationServices_Wrap).insertAfter($('#gf-products li:nth-child(10)'));

        //let topRatedProductSlider_Wrap = $('#topRatedProductSlider_Wrap').html();
        //$(topRatedProductSlider_Wrap).insertAfter($('#gf-products li:nth-child(14)'));
        

        let sliderWidth = $('#gf-products').outerWidth();
        $('.productSliderInner, .powerType ul').css('max-width', sliderWidth);
        initPowerTypeSlider();
      

        $('.productSliderCarousel').owlCarousel('destroy');
        $('.productSliderCarousel').owlCarousel({
        dots: false,
        loop: true,
        autoplay: true,
        nav: true,
        navText: ['<svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none"><path d="M13.4557 1.71933L6.59908 8.65L13.4551 15.5807L12.3884 16.6353L4.48975 8.65L12.3897 0.66333L13.4564 1.71866L13.4557 1.71933Z" fill="black"/></svg>', '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none"><path d="M3.51385 1.71933L10.3699 8.65L3.51385 15.5807L4.58052 16.6353L12.4798 8.65L4.57985 0.66333L3.51318 1.71866L3.51385 1.71933Z" fill="black"/></svg>'],
        responsiveClass:false,
        onInitialized: updateCounter11,
        onChanged: updateCounter11,
        responsive:{
            0:{
               items:1,
               margin:0
            },
            480:{
               items:2,
               margin:0
            },
            750:{
                items:1,
               margin:20
            },
            990:{
                items:2,
               margin:20
            },
           1080:{
               items:3,
               margin:20 
            },
            1280:{
               items:4,
               margin:20 
            },
           1600:{
               items:5,
               margin:20
            }
        }
     })
      
      },2000);

    $('body').on('click', '.gf-option-box li button', function(){
      setTimeout(function(){
        //let powerhtml = $('.powerType').html();
        //$('<div class="powerType">'+powerhtml+'</div>').insertBefore($('#gf-controls-container'));
        
        let topProductSlider_Wrap = $('#topProductSlider_Wrap').html();
        $(topProductSlider_Wrap).insertAfter($('#gf-products li:nth-child(6)'));
        
        let installationServices_Wrap = $('#installationServices_Wrap').html();
        $(installationServices_Wrap).insertAfter($('#gf-products li:nth-child(10)'));

        //let topRatedProductSlider_Wrap = $('#topRatedProductSlider_Wrap').html();
        //$(topRatedProductSlider_Wrap).insertAfter($('#gf-products li:nth-child(14)'));

        $('.productSliderCarousel').owlCarousel('destroy');
        $('.productSliderCarousel').owlCarousel({
        dots: false,
        loop: true,
        autoplay: true,
        nav: true,
        navText: ['<svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none"><path d="M13.4557 1.71933L6.59908 8.65L13.4551 15.5807L12.3884 16.6353L4.48975 8.65L12.3897 0.66333L13.4564 1.71866L13.4557 1.71933Z" fill="black"/></svg>', '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none"><path d="M3.51385 1.71933L10.3699 8.65L3.51385 15.5807L4.58052 16.6353L12.4798 8.65L4.57985 0.66333L3.51318 1.71866L3.51385 1.71933Z" fill="black"/></svg>'],
        responsiveClass:false,
        onInitialized: updateCounter11,
        onChanged: updateCounter11,
        responsive:{
            0:{
               items:1,
               margin:0
            },
            480:{
               items:2,
               margin:0
            },
            750:{
                items:1,
               margin:20
            },
            990:{
                items:2,
               margin:20
            },
           1080:{
               items:3,
               margin:20 
            },
            1280:{
               items:4,
               margin:20 
            },
           1600:{
               items:5,
               margin:20
            }
        }
     })
        
       },2000);  
    });                                   
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["one-stop"] && !Shopify.designMode) return;
  try {
    
    $(document).ready(function(){
      $('.oneStepCarousel').owlCarousel({
        loop:false,
        margin:0,
        dots: false,
        autoplay: false,
        nav: false,
        items:1
     })
  })

  } catch(e) { console.error(e); }
})();
})();
